/*
@file-overview 

- This service was brougth over from AEM wcax-commons repo

- Contains utility methods for interacting with Adobe Target

*/
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ABTestService {

  public _abTargetLoadedState = new BehaviorSubject<boolean>(false);
  public abTargetLoadedState$ = this._abTargetLoadedState.asObservable();

  constructor() {
    if (this.isTargetLoadComplete()) {
      this._abTargetLoadedState.next(true);
    }
    else {
      console.warn("========> AB TESTING ====> target flag is not loaded");

      // The flag has not been loaded yet - add a listener and notify
      // all observers when it is loaded.
      window.addEventListener('AdobeTarget-Complete', (e) => {
        console.warn("========> AB TESTING ====> AdobeTarget-Complete event listener called");
        this.setGRSSpecificParamsInLS();
        this._abTargetLoadedState.next(true);
      }, { once: true });
    }
  }


  public isTargetLoadComplete() {
    let loaded = false;
    const mboxDisable = window['AB']['COMMON']['getURLParameterByName']('mboxDisable');


    if ((mboxDisable && (mboxDisable === 1 || mboxDisable === true)) ||
        window['analyticsSwy'] && 
        window['analyticsSwy']['testFlags'] && 
        window['analyticsSwy']['testFlags'][`AdobeTarget-Complete`] == true )
      loaded = true;

      return loaded;
  }

  public setGRSSpecificParamsInLS = function(){
      const disableGrsEndpoint = window['SWY']['CONFIGSERVICE']
      && window['SWY']['CONFIGSERVICE'].featureToggleConfig
      && window['SWY']['CONFIGSERVICE'].featureToggleConfig.hasOwnProperty('disableGrsEndpoint')
          ? window['SWY']['CONFIGSERVICE'].featureToggleConfig.disableGrsEndpoint
          : true;
      if (
          !disableGrsEndpoint
          && window['analyticsSwy']
          && window['analyticsSwy']['testFlags']
          && window['analyticsSwy']['testFlags']['EOT_1835']
          && window['analyticsSwy']['testFlags']['EOT_1835'].toLowerCase() === 'a'
      ) {
          window['AB']['COMMON'].setUpdateVisitorIdForGrs();
          window['AB']['COMMON'].setSessionIdForGrs();
      }
  }

  private isABTestingDisabled() : boolean {
    let abDisabled = false;

    const queryParams = new URLSearchParams(window.location.search);
    const mboxFlag = queryParams.get('mboxDisable');
    if (mboxFlag && (mboxFlag == "1" || mboxFlag.toLowerCase() == "true")) {
      abDisabled = true;
    }

    return abDisabled;
  }

  public getTargetFlagValue(targetFlag) {
    return window['analyticsSwy']
        && window['analyticsSwy']['testFlags']
        && window['analyticsSwy']['testFlags'][targetFlag];
  }

}
